module.exports = __webpack_public_path__ + "img/flag-PT.2a5ba7ed.png";